import React from 'react'
import './Components/Covid_Data'
import Covid_Data from './Components/Covid_Data'

const App = () => {
  return (
    <Covid_Data/>
  )
}

export default App